module.exports = "<div *ngIf=\"file\">\n\n  <div *ngIf=\"!onlySize && !onlyName\">\n    <label>\n      {{file.name}} ({{humanReadableFileSize(file.size)}})\n    </label>\n  </div>\n\n  <div *ngIf=\"onlySize\">\n    <label>\n      Size {{humanReadableFileSize(file.size)}}\n    </label>\n  </div>\n\n  <div *ngIf=\"onlyName\">\n    <p>\n      {{file.name}}\n    </p>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/file-description/file-description.component.html
// module id = ../../../../../src/app/file-description/file-description.component.html
// module chunks = main